<!--suppress ALL -->
<template>
  <g-field :label="title" :type="type" :message="message" class="auto-complete">
    <g-autocomplete v-model="santriNameFormated" :data="santriFilter"
                    field="nama_lengkap" :placeholder="placeholder"
                    @select="onSelectSantri" open-on-focus :isLoading="isLoading">
      <span slot="iconRight" class="tooltip" :data-tooltip="$t('text.reset_search')"
            :class="santris.length === 0 && applySearchOnType ? '' : 'is-hidden'"
            @click="onResetOnTypeSearch">
          <i class="far fa-times"></i>
      </span>

      <div slot-scope="{option}" class="media">
        <div class="media-content">
          <strong>{{ option.nama_lengkap }}</strong>
          <br>
          <small>
            <span>{{ option.nomor || "-" }}</span>
            <br>
            <span
              v-if="showPengajian">{{ getPenerimaDana(option.wilayah) || "-" }} / {{ getPengajian(option.pengajian) || "-" }}</span>
            <span v-else>{{ getPenerimaDana(option.wilayah) || "-" }}</span>
          </small>
        </div>
      </div>

      <div slot="empty" class="has-text-centered">
        <p class="title is-6">{{ $t("text.no_content_loaded") }}</p>
      </div>

      <div slot="footer" class="has-text-centered"
           :class="{'is-hidden': !(hasMoreData && applySearchOnType)}">
        <a @click="doFind(santris.length)">{{ $t("label.load_more") }}</a>
      </div>
    </g-autocomplete>
  </g-field>
</template>

<script lang="ts">
import { Component, Vue, Watch, Prop, Container } from "annotation";
import cloneDeep from "lodash/cloneDeep";
import debounce from "lodash/debounce";
import AppConfig from "../../../AppConfig";
import environment from "environment";
import Response from "../../../service/Response";
import SantriService from "../../../service/SantriService";
import Santri from "../../../entity/Santri";
import { getPenerimaDana, getPengajian } from "../../../util/PluralVariabels";

@Component({
  methods: { getPengajian, getPenerimaDana }
})
export default class SantriAutoComplete extends Vue {

  private get santriService(): SantriService {
    return Container.get(SantriService);
  }

  @Prop({
    default: () => {
      return AppConfig.getVm().$t("label.nama_santri");
    }
  })
  public placeholder: any;

  @Prop({
    default: () => AppConfig.getVm().$t("label.pencarian_santri")
  })
  public title: any;

  @Prop({ type: String, default: "" })
  public santriName: string;

  @Prop({ type: String, default: null })
  public type: any;

  @Prop({ type: String, default: null })
  public message: any;

  @Prop({ type: Boolean, default: false })
  public applySearchOnType: boolean;

  @Prop({ type: Boolean, default: false })
  public showPengajian: boolean;

  public santriNameFormated: string = "";

  public isLoading: boolean = false;

  public hasMoreData: boolean = false;

  @Watch("santriName", { immediate: true })
  public onSantriNameChange(val: string) {
    if (val) {
      this.santriNameFormated = val;
    }
  }

  @Watch("santriNameFormated")
  public onSantriNameFormatedChange() {
    if (this.applySearchOnType) {
      this.onTypingSantri();
    }
  }

  @Watch("applySearchOnType", { immediate: true })
  public onApplySearchOnType(val: boolean) {
    if (val) {
      this.doFind();
    }
  }

  private santris: Array<Santri> = [];

  public get santriFilter() {
    const filteredPendaftar: Array<any> = this.santris.filter((item: Santri) => {
      let { nama_lengkap } = item;

      return nama_lengkap.toLowerCase().includes(this.santriNameFormated.toLowerCase());
    });

    return filteredPendaftar.length > 0 ? filteredPendaftar : this.santris;
  }

  public mounted() {
    if (!this.applySearchOnType) {
      this.doFind();
    }
  }

  public async doFind(page: number = 0) {
    if (!this.applySearchOnType) this.isLoading = true;

    const fixedLimit: number = environment[this.applySearchOnType ? "LIMIT" : "MAX_LIMIT"];
    let fixedPage: number = page;

    if (fixedPage > 0) {
      fixedPage = Math.ceil(fixedPage / fixedLimit);
    }

    const param: any = { page: fixedPage, size: fixedLimit };

    if (this.applySearchOnType && this.santriNameFormated.length >= environment["MAX_CHAR_SEARCH_NAME"]) {
      param["nama"] = this.santriNameFormated;
    }
    
    const response: Response = await this.santriService.find(param);
    
    if (response.isSuccess) {
      if (this.applySearchOnType) {
        response.getDeserializeResponse([]).forEach((item: Santri) => this.santris.push(item));

        this.hasMoreData = this.santris.length < response.getRows(0);
      } else {
        this.santris = response.getDeserializeResponse([]);
      }
    }

    if (!this.applySearchOnType) this.isLoading = false;
  }

  public onSelectSantri(santri: Santri) {
    if (santri) {
      this.$emit("select-santri", cloneDeep(santri));
    }
  }

  public onResetOnTypeSearch() {
    this.santriNameFormated = "";
    this.isLoading = true;

    this.doFind().then(() => this.isLoading = false);
  }

  public created() {
    this.onTypingSantri = debounce(() => {
      if (this.santriNameFormated.length < environment["MAX_CHAR_SEARCH_NAME"]) {
        return;
      }

      this.isLoading = true;
      this.santris = [];
      this.doFind().then(() => this.isLoading = false);
    }, 500);
  }

  public onTypingSantri: any;
}
</script>
